export type CasinoKpiFilterOption = {
  value: string;
  label: string;
};

export type CasinoKpiFilterValues = {
  money_type: string[];
};

export type CasinoKpiFilterMetadata = {
  options: CasinoKpiFilterOption[];
  available: boolean;
};

export const buildCasinoKpiMoneyTypeParam = (moneyType?: string[]) =>
  moneyType?.length ? { money_type: moneyType.join(",") } : {};

type RawFilter = {
  key?: unknown;
  options?: unknown;
};

const formatFilterLabel = (value: string): string =>
  value
    .split("_")
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(" ");

const findFilterArray = (
  value: unknown,
  depth = 0,
): RawFilter[] | undefined => {
  if (depth > 4 || value === null || value === undefined) return undefined;
  if (Array.isArray(value)) {
    return value.some(
      (entry) =>
        typeof entry === "object" &&
        entry !== null &&
        typeof (entry as RawFilter).key === "string",
    )
      ? (value as RawFilter[])
      : undefined;
  }
  if (typeof value !== "object") return undefined;

  for (const nestedValue of Object.values(value as Record<string, unknown>)) {
    const filters = findFilterArray(nestedValue, depth + 1);
    if (filters) return filters;
  }
  return undefined;
};

export const parseCasinoKpiFilterMetadata = (
  body: unknown,
): CasinoKpiFilterMetadata => {
  const moneyTypeFilter = findFilterArray(body)?.find(
    (filter) => filter.key === "money_type",
  );
  const options = Array.isArray(moneyTypeFilter?.options)
    ? moneyTypeFilter.options
        .filter((value): value is string => typeof value === "string")
        .map((value) => value.trim())
        .filter(Boolean)
        .map((value) => ({ value, label: formatFilterLabel(value) }))
    : [];

  return {
    options,
    available: options.length > 0,
  };
};
